"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const is_empty_1 = __importDefault(require("../../utils/is-empty"));
const message_defaults_json_1 = __importDefault(require("../../message-defaults.json"));
const messageDefault = message_defaults_json_1.default.postcode;
const validationBuilder = (message = messageDefault) => (value) => {
    if (!(0, is_empty_1.default)(value)) {
        // Replace all non-digits (This is likely to be the placeholder underscores)
        const transformed = lodash_1.default.replace(String(value), /[^0-9]+/g, '');
        // Ensure that the transformed postcode is 4 chars long
        if (transformed.length !== 4) {
            return message;
        }
    }
    return null;
};
validationBuilder.messageDefault = messageDefault;
exports.default = validationBuilder;
